export default interface IBiomesMetadata {}
